export default __webpack_public_path__ + "static/media/support.35c7967b.svg";